/* global app: false */
app.controller('SearchResults.Controller', function ($scope) {
    $scope.numberOfResults = undefined;

    $scope.$on('updatePaging', function (event, args) {
        $scope.numberOfResults = args.TotalResults;
    });
});
